import { Box } from "@mui/material";
import { forwardRef, Fragment, Ref, useState } from "react";
import ContentAdmin from "../../../../components/contentAdmin";
import PanelTitle from "../../../../components/missions/PanelTitle";
import Activities from "./feature/Activities";
import Buttons from "./feature/Buttons";
import Environment from "./feature/Environment";
import People from "./feature/People";

const ClockMorning = forwardRef((
	props: Record<string, any>,
	ref: Ref<HTMLDivElement>
) =>
{
	const [ stepClockMorning, setStepClockMorning ] = useState<number>(1);
	const [ disabledButtons, setDisabledButtons ] = useState<[ boolean, boolean, boolean ]>([ true, true, true ]);

	function handleBlip(key: number)
	{
		setDisabledButtons((prevState) => (
			Object.assign([], prevState, { [ key ]: false })
		));
	}

	const Components = [
		<Buttons setStepClockMorning={setStepClockMorning} disabledButtons={disabledButtons} handleBlip={handleBlip} />,
		<Environment setStepClockMorning={setStepClockMorning} />,
		<Activities setStepClockMorning={setStepClockMorning} />,
		<People setStepClockMorning={setStepClockMorning} />
	];

	return (
		<Box ref={ref} {...props} sx={{ flexDirection: "column", display: "flex", justifyContent: "space-between", height: "81vh", width: "100%", maxWidth: { xl: "980px", xs: "784px" }, m: "10px auto 0px" }}>
			<Box sx={{ maxWidth: "100%", mt: "-5px" }}>
				<PanelTitle
					positionOcta
					imageVariation="closeEye"
					title={<ContentAdmin limit={111} keyContent="contentMissionFive" keyText="clock_morning_title" defaultValue="Design your morning" position="right" />}
				/>
				{/* <TransitionGroup className="TransitionGroup">
					{Components.map((Component, index) =>
					{
						if (stepClockMorning === index + 1)
						{
							return (
								<Grow key={index} timeout={{ enter: 1000, exit: 0 }} unmountOnExit>
									{Component}
								</Grow>
							);
						}
						return <Fragment key={index}></Fragment>;
					})}
					{stepClockMorning > Components.length && <Grow timeout={{ enter: 1000, exit: 0 }} unmountOnExit><h1>Step {stepClockMorning}</h1></Grow>}
				</TransitionGroup> */}
				{Components.map((Component, index) =>
				{
					if (stepClockMorning === index + 1)
					{
						return (
							<Box key={index}>{Component}</Box>
						);
					}

					return <Fragment key={index} />;
				})}
			</Box>
		</Box>
	);
});

export default ClockMorning;
